import Alpine from 'alpinejs';

Alpine.data('accordion', (behavior, initialOpen = 0) => ({
  openItems: Array.from({ length: initialOpen }, (_, i) => i),

  toggle(index) {
    const wasOpen = this.openItems.includes(index);

    if (behavior === 'single') {
      this.openItems = wasOpen ? [] : [index];
    } else {
      if (wasOpen) {
        this.openItems = this.openItems.filter(i => i !== index);
      } else {
        this.openItems.push(index);
      }
    }

    // Move focus to body content when opening. Scoped to THIS
    // accordion via $root (multiple accordion blocks on a page would
    // otherwise share the same nth body element via getElementById).
    // preventScroll keeps `scroll-behavior: smooth` on html from
    // jumping the page when the focus target sits above the viewport.
    if (!wasOpen) {
      this.$nextTick(() => {
        const bodyEl = this.$root.querySelectorAll('.accordion__body')[index];
        if (bodyEl) {
          bodyEl.focus({ preventScroll: true });
        }
      });
    }
  },

  isOpen(index) {
    return this.openItems.includes(index);
  }
}));